export default {"src":"https://s.sylndr.com/c-0ea2b57/_next/static/media/SeeCarIcon.7efc3a84.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};